export const FETCH_GOLF_COURSE = 'FETCH_GOLF_COURSE';
export const FETCH_GOLF_COURSE_SUCCESS = 'FETCH_GOLF_COURSE_SUCCESS';
export const FETCH_GOLF_COURSE_FAIL = 'FETCH_GOLF_COURSE_FAIL';

export const FETCH_GOLF_COURSE_STATS = 'FETCH_GOLF_COURSE_STATS';
export const FETCH_GOLF_COURSE_STATS_SUCCESS = 'FETCH_GOLF_COURSE_STATS_SUCCESS';
export const FETCH_GOLF_COURSE_STATS_FAIL = 'FETCH_GOLF_COURSE_STATS_FAIL';

export const FETCH_GOLF_COURSE_LAYOUTS = 'FETCH_GOLF_COURSE_LAYOUTS';
export const FETCH_GOLF_COURSE_LAYOUTS_SUCCESS = 'FETCH_GOLF_COURSE_LAYOUTS_SUCCESS';
export const FETCH_GOLF_COURSE_LAYOUTS_FAIL = 'FETCH_GOLF_COURSE_LAYOUTS_FAIL';

export const FETCH_GOLF_COURSES = 'FETCH_GOLF_COURSES';
export const FETCH_GOLF_COURSES_SUCCESS = 'FETCH_GOLF_COURSES_SUCCESS';
export const FETCH_GOLF_COURSES_FAIL = 'FETCH_GOLF_COURSES_FAIL';

export const FETCH_GOLF_COURSE_SCORECARDS = 'FETCH_GOLF_COURSE_SCORECARDS';
export const FETCH_GOLF_COURSE_SCORECARDS_SUCCESS = 'FETCH_GOLF_COURSE_SCORECARDS_SUCCESS';
export const FETCH_GOLF_COURSE_SCORECARDS_FAIL = 'FETCH_GOLF_COURSE_SCORECARDS_FAIL';
